import { render, staticRenderFns } from "./notification-bell.vue?vue&type=template&id=54e217ed&scoped=true"
import script from "./notification-bell.vue?vue&type=script&lang=js"
export * from "./notification-bell.vue?vue&type=script&lang=js"
import style0 from "./notification-bell.vue?vue&type=style&index=0&id=54e217ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e217ed",
  null
  
)

export default component.exports